// 兼容低版本浏览器
import 'url-search-params-polyfill'
import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
// 神策js引入，及方法
import '@/assets/js/analysis.js'
import { setToken } from './assets/js/utils'
// import { obj } from './assets/js/encryption/aesTools'
import './index.css'
import App from './router'
import ErrorBoundary from './pages/ErrorBoundary'
import '@/assets/js/flexible.js'
// if (process.env.REACT_APP_NODE_ENV) { import('./mock/mock')}
console.log('20250904')
// 设置token
setToken()
// obj()
ReactDOM.render(<ErrorBoundary><App /></ErrorBoundary>, document.getElementById('root'))
